export default "__VITE_ASSET__BkCbLNLi__ 224w, __VITE_ASSET__ncb8M1pB__ 448w";